// Trimmed to event names that actually exist in the ClickHouse seed data —
// see pmw-click-backend/src/seed/seedClickHouse.js for the authoritative list.
export const APP_EVENTS = [
  'app_install', 'app_open', 'screen_view', 'button_click', 'search',
  'app_update', 'notification_received', 'notification_opened', 'deep_link_opened',
  'lead_added', 'earning_initiated', 'task_submitted',
  'kyc_initiated', 'kyc_submitted', 'kyc_approved', 'kyc_rejected',
];

// Legacy fixed presets — still used by the journey builder's (unsupported)
// logic-condition node. The segment builder's own time window is a free
// number + unit pair now (see TIME_WINDOW_UNITS) rather than picked from here.
export const TIME_WINDOWS = [
  { label: 'last 1 hour', value: 1, unit: 'hours' },
  { label: 'last 6 hours', value: 6, unit: 'hours' },
  { label: 'last 24 hours', value: 24, unit: 'hours' },
  { label: 'last 7 days', value: 7, unit: 'days' },
  { label: 'last 14 days', value: 14, unit: 'days' },
  { label: 'last 30 days', value: 30, unit: 'days' },
  { label: 'last 60 days', value: 60, unit: 'days' },
  { label: 'last 90 days', value: 90, unit: 'days' },
  { label: 'last 6 months', value: 6, unit: 'months' },
];

// Must match what the backend's queryBuilder/timeWindow.util accepts exactly.
export const TIME_WINDOW_UNITS = ['hours', 'days', 'weeks', 'months'];

// The backend only supports "did the event at all" or "did it more than N
// times" — no "exactly"/"at most". Trimmed rather than offering options that
// would silently do the wrong thing.
export const COUNT_OPS = ['at least'];

// Event properties are arbitrary per-event data, not a fixed catalog — any
// event can carry any property (e.g. lead_added: { source: "referral" },
// button_click: { button_id: "btn_12" }). So the property name is free text
// here, not a dropdown sourced from a schema.
export const PROPERTY_OPS = ['equals', 'not equals', 'greater than', 'less than', 'is set', 'is not set'];

export const FILTER_TYPES = {
  event: {
    label: 'Event',
    col: 'rgba(184,66,66,.13)',
    tc: '#C86060',
  },
  'event-performed': {
    label: 'Did',
    col: 'rgba(79,155,111,.13)',
    tc: '#63B887',
  },
  'event-not-performed': {
    label: 'Did Not',
    col: 'rgba(160,124,48,.13)',
    tc: '#C09848',
  },
  'user-property': {
    label: 'Profile',
    col: 'rgba(72,120,176,.13)',
    tc: '#6090C8',
    props: ['Platform', 'City', 'Language', 'KYC Status'],
    ops: ['equals', 'not equals'],
    valsByProp: {
      Platform: ['iOS', 'Android', 'Web'],
      City: ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Pune', 'Ahmedabad', 'Kolkata'],
      Language: ['hi', 'en', 'mr', 'ta', 'te'],
      'KYC Status': ['approved', 'submitted', 'initiated', 'rejected'],
    },
  },
  'entity-status': {
    label: 'Status',
    col: 'rgba(122,110,176,.13)',
    tc: '#A09AC8',
    props: ['Lead Status', 'Earning Status', 'Task Status'],
    ops: ['equals', 'not equals'],
    valsByProp: {
      'Lead Status': ['pending', 'verified', 'rejected'],
      'Earning Status': ['paid', 'processed', 'reversed'],
      'Task Status': ['verified', 'submitted', 'pending', 'rejected'],
    },
  },
  earning: {
    label: 'Earning',
    col: 'rgba(79,155,111,.12)',
    tc: '#63B887',
    props: ['Project Commission', 'Recharge Commission', 'Referral Bonus', 'Task Reward'],
    ops: ['≥'],
    needsTimeWindow: true,
    numericValue: true,
  },
  campaign: {
    label: 'Campaign',
    col: 'rgba(160,124,48,.12)',
    tc: '#C09848',
    props: ['Push', 'In-App', 'SMS', 'Email', 'WhatsApp', 'RCS', 'IVR'],
    ops: ['not sent today'],
    noValue: true,
  },
};
